// This file is AUTOGENERATED, do not edit it manually!!!

export const imageAnnotations = {
    apply: 'Toepassen',
    back: 'Terug naar berichten',
    cancel: 'Annuleren',
    comment: 'Commentaar',
    commented_on_image: 'heeft gereageerd op de afbeelding',
    comments: 'Reacties',
    delete: 'Verwijderen',
    delete_comment: 'Deze reactie verwijderen?',
    deleted_image: 'Afbeelding is verwijderd',
    download: 'Afbeelding downloaden',
    edit: 'Bewerken',
    no_comment: 'Geen reacties om weer te geven',
    write_comment: 'Schrijf je reactie',
};
